export default __webpack_public_path__ + "static/media/character6.1179210f.png";